<template>
  <v-container class="site-padding">
    <v-layout align-center justify-center row wrap class="py-3 timer-container">
      <v-flex xs12 md3 class="text-xs-left py-3 pr-3">
        <div class="timer-container--wrapper">
          <h1 class="timer-container--header">Do rozpoczęcia transmisji pozostało:</h1>
        </div>
      </v-flex>
      <v-flex xs12 md2 class="text-xs-left py-3">
        <v-avatar
          :size="100"
          color="rgb(222, 222, 222)"
        >
          <span class="numberCircle">{{ days | twoDigits }}</span>
        </v-avatar>
        <span class="text">dni</span>
      </v-flex>
      <v-flex xs12 md2 class="text-xs-left py-3">
        <v-avatar
          :size="100"
          color="rgb(222, 222, 222)"
        >
          <span class="numberCircle">{{ hours | twoDigits }}</span>
        </v-avatar>
        <span class="text">godz.</span>
      </v-flex>
      <v-flex xs12 md2 class="text-xs-left py-3">
        <v-avatar
          :size="100"
          color="rgb(222, 222, 222)"
        >
          <span class="numberCircle">{{ minutes | twoDigits }}</span>
        </v-avatar>
        <span class="text">min.</span>
      </v-flex>
      <v-flex xs12 md2 class="text-xs-left py-3">
        <v-avatar
          :size="100"
          color="rgb(222, 222, 222)"
        >
          <span class="numberCircle">{{ seconds | twoDigits }}</span>
        </v-avatar>
        <span class="text">sek.</span>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment';

export default {
  props: ['date'],
  data() {
    return {
      now: Math.round((new Date()).getTime() / 1000),
      modifiedDate: Math.round(moment(this.date.toString()) / 1000),
    };
  },
  components: {
    moment,
  },
  ready() {
    window.setInterval(() => {
      this.now = Math.round((new Date()).getTime() / 1000);
    }, 1000);
  },
  mounted() {
    var ctx = this;
    setInterval(function(){
      ctx.now = Math.round((new Date()).getTime() / 1000);
    }, 1000);
  },
  computed: {
    days() {
      let transmission = moment(this.date.toString());
      return (transmission.diff(moment(new Date()), 'days'));
    },
    seconds() {
      return (this.modifiedDate - this.now) % 60;
    },
    minutes() {
      return Math.round((this.modifiedDate - this.now) / 60) % 60;
    },
    hours() {
      return Math.round((this.modifiedDate - this.now) / 60 / 60) % 24;
    },
  },
  filters: {
    // Filter definitions
    twoDigits(value) {
      if (value.toString().length <= 1) {
        return '0' + value.toString();
      }
        return value.toString();
      }
    }
  }
</script>
<style scoped>
.timer-container--header {
    font-size: 26px;
    line-height: 26px;
    color: #9a1c1e;
    text-align: left;
    font-weight: 900;
    font-family: 'Fira Sans', sans-serif;
}
.timer-container--wrapper {
    width: 100%;
    margin: 0 auto;
}
.numberCircle {
  width: 100%;
  color: #9a1c1e;
  text-align: center;
  font-weight: 900;
  font-family: 'Fira Sans', sans-serif;
  font-size: 50px;
}
.block {
  display: flex;
  flex-direction: column;
  border-style: solid;
  border-color: #9a1c1e;
  border-radius: 50%;
  line-height: 1;
}

.text {
  color: #252525;
  font-size: 16px;
  font-family: 'Fira Sans', sans-serif;
  font-weight: 40;
  text-align: center;
  padding-left: 15px;
}

@media screen and (max-width: 768px) {
  .digit {
    font-size: 35px;
    font-weight: 35;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/Countdown2.vue